import { useEffect } from 'react'
import { Benefits, DevelopmentProcess, EngagementModel, FAQ, HireWebSection, RecentWork, Review, RoadmapSection, ServiceHeader, TechData, TrailSection } from '../../../components'
import { recentworkdataAll } from '../Ecover/data'
import { BenefitsData, developmentProcessData, DevelopmentServicesData, FAQData, headerData, hireWebData, ModelData, recentworkdata, reviewData, SuccessDrivenData, techData } from './data'

const ContentWriter = () => {

    useEffect(() => {

        window.scrollTo(0, 0)

    }, [])

    return (
        <div className=' pt-[52px] md:pt-[70px]'>
            <div className='dark:bg-gray-900 transition-all duration-700'>
                <ServiceHeader data={headerData} />
            </div>
            <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
                <Benefits data={BenefitsData} />
            </div>
            <div className='dark:bg-gray-900 transition-all duration-700'>
                <RecentWork  />
            </div>
            <TrailSection />
            <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
                <Benefits data={SuccessDrivenData} sucessDriven={true} />
            </div>
            <div className='dark:bg-gray-900 transition-all duration-700'>
                <DevelopmentProcess data={developmentProcessData} />
            </div>
            <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
                <Benefits data={DevelopmentServicesData} devServices={true} sucessDriven={true} />
            </div>
            <div className='dark:bg-gray-900 transition-all duration-700'>
                <HireWebSection data={hireWebData} />
            </div>
            <div>
                <RoadmapSection title='Content Writing' />
            </div>
            <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
                <EngagementModel data={ModelData} />
            </div>
            <div className='dark:bg-gray-900 transition-all duration-700'>
                <TechData />
            </div>
            <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
                <Review data={reviewData} />
            </div>
            <div className='dark:bg-gray-900 transition-all duration-700'>
                <FAQ data={FAQData} />
            </div>

        </div>
    )
}

export default ContentWriter